import { styled } from "@mui/material/styles";
import PhoneInput from "react-phone-input-2";

export const PhoneNumberContainer = styled("div")(({ theme }) => ({
    display: "flex",
    width: theme.space._1300,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._500,
    alignSelf: "stretch",

    "@media (max-width: 600px)": {
        width: "100%"
    }
}));

export const CustomPhoneInput = styled(PhoneInput)(({ theme }) => ({
    "& input": {
        border: `1px solid ${theme.colors["neutral.600"]}!important`,
        height: '2rem',
        width: "100%!important",
        backgroundColor: `${theme.colors["neutral.900"]}!important`,
        color: `${theme.colors["neutral.50"]}!important`
    },
    "& ul": {
        backgroundColor: `${theme.colors["neutral.900"]}!important`,
        color: `${theme.colors["neutral.50"]}!important`,
        "& li:hover": {
            backgroundColor: `${theme.colors["neutral.950"]}!important`,
            color: `${theme.colors["white"]}!important`,
            opacity: "1.5!important",
        },
        "& li.highlight": {
            backgroundColor: `${theme.colors["neutral.950"]}!important`,
            color: `${theme.colors["white"]}!important`,
            opacity: "1.5!important",
        }
    },
}));
